/* eslint-disable func-names */
/* eslint-disable no-lonely-if */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-spread */
/* eslint-disable no-console */
import { createAtom } from 'mobx';

import { analytics } from 'core/analytics';
import {
  WasmObservableError,
  WasmObservableException,
} from 'libs/rendering/gltf/api/errors';

// wasm signature checks (fetched from --post-js post.js)
const typeMapNames = ['_argsTypeMap', '_retTypeMap'];
const getWasmCallSignature = (prototype, propName) => {
  const args = prototype[typeMapNames[0]]?.get(propName);
  const ret = prototype[typeMapNames[1]]?.get(propName);
  return [args, ret];
};

export const isWasmObject = wasmObject => {
  if (wasmObject && wasmObject.$$) return true;
  return false;
};

// wasm object check
const checkWasmObject = wasmObject => {
  if (
    wasmObject == null ||
    wasmObject.$$ == null ||
    !wasmObject.$$.count ||
    wasmObject.$$.ptrType == null ||
    wasmObject.$$.ptrType.name.length === 0 ||
    wasmObject.$$.ptrType.registeredClass == null ||
    wasmObject.$$.ptrType.registeredClass.instancePrototype == null
  ) {
    return false;
  }
  return true;
};

// typeof checks...
const isFunction = entry => {
  if (typeof entry === 'function') {
    return true;
  }
  return false;
};

const iterableTypeTokens = { map: 'map<', vector: 'vector<' };

const wasmObservablesFail = (viewerControl, err, attName = undefined) => {
  const scopingFunction = scope => {
    scope.setTag('subsystem', 'wasm-observables');
    scope.setTag('attName', attName);
  };

  if (viewerControl) {
    viewerControl.LogException(err, scopingFunction);
  } else {
    analytics.logError(err, scopingFunction);
  }
};

const getIterableType = (entry, viewerControl) => {
  if (typeof entry === 'object') {
    if (checkWasmObject(entry)) {
      // it is a proper wasm object
      const objInfo = entry.$$.ptrType;
      const cleanName = objInfo.name.replace(/\s/g, '');
      if (objInfo && cleanName) {
        return getIterableTypeForLabel(cleanName);
      }
    } else if (Object.prototype.toString.call(entry) === '[object Array]') {
      // array (no error, deal with it as normal attribute getter)...
      return [null, null];
    } else if (Object.prototype.toString.call(entry) === '[object Object]') {
      if (!Number.isNaN(entry?.value) && entry?.value >= 0) {
        // enum (no error, deal with it as normal attribute getter)...
        return [null, null];
      }
    }
    wasmObservablesFail(
      viewerControl,
      new WasmObservableError(`non recognized iterable object: ${entry}`),
    );
  }
  return [null, null];
};

const getIterableTypeForLabel = (labelStr, viewerControl) => {
  if (labelStr) {
    // check all iterable types...
    for (const typeToken in iterableTypeTokens) {
      if (labelStr.includes(iterableTypeTokens[typeToken])) {
        // recognized iterable type
        const refTypeStart = labelStr.indexOf('<') + 1;
        const refTypeEnd = labelStr.indexOf('>');
        const refTypeStr = labelStr.substring(refTypeStart, refTypeEnd);
        if (refTypeStr.length > 0) {
          const refTypeArr = refTypeStr.split(',');
          if (refTypeArr.length > 0 && refTypeArr.length <= 2) {
            return [typeToken, refTypeArr];
          }
        }
        wasmObservablesFail(
          viewerControl,
          new WasmObservableError(`error reading iterable labels: ${labelStr}`),
        );
      }
    }
  }
  return [null, null];
};

// global IDs
const getUuid = wasmObj => {
  const objInfo = wasmObj.$$.ptrType;
  const cleanObjName = objInfo.name.replace('*', '');

  let mapKey = `${cleanObjName}.${wasmObj.$$.ptr}`;
  if (wasmObj.uuid) {
    // use uuid for obejxts inheriting from [ModelItem]
    mapKey = `${cleanObjName}.${wasmObj.uuid}`;
  } else if (wasmObj.id && cleanObjName === 'NoteEmbind') {
    // use id for Notes
    mapKey = `${cleanObjName}.${wasmObj.id}`;
  }

  return mapKey;
};

const _debug = false;
const _debug2 = false;
const debugLogPre = '>';
const debugLogInnerPre = '  |';
const debugLogInnerPreProt = `${debugLogInnerPre} ${debugLogPre}`;
const debugRetLog = '⮕';

// atom wrapper
const atomPrefix = 'atom.wrapped-cpp';
export const makeWasmObservable = (obsMap, wasmObj, viewerControl) => {
  if (!checkWasmObject(wasmObj)) {
    wasmObservablesFail(
      viewerControl,
      new WasmObservableError(
        `cannot makeWasmObservable on wasm object ${wasmObj}`,
      ),
    );
    return null;
  }

  const objInfo = wasmObj.$$.ptrType;
  const cleanObjName = objInfo.name.replace('*', '');
  const mapKey = getUuid(wasmObj);

  // check existent object
  if (obsMap.has(mapKey)) {
    const wasm = obsMap.get(mapKey)._wasm;
    const check = checkWasmObject(wasm);
    if (!check) {
      viewerControl.logWarn('invalid mapped wasm object !!!');
      obsMap.delete(mapKey);
    }
  }

  if (!obsMap.has(mapKey)) {
    if (_debug) console.log('WRAPPING wasmObserver', mapKey, wasmObj);

    // new observable (wrapper) object...
    const wasmObs = {
      _mapKey: mapKey,
      _wasm: wasmObj,
      _atom: createAtom(
        `${atomPrefix}.${cleanObjName}`,
        () => {},
        () => {
          obsMap.delete(mapKey);
        },
      ),
    };

    // to force a reportChanged
    wasmObs.reportWasmChange = function () {
      wasmObs._atom.reportChanged();
    };
    // to manage "silent" changes
    // (no atom report, so can be used inside reactions)
    wasmObs.startSilentWasmChange = function () {
      this.silent = true;
    };
    wasmObs.endSilentWasmChange = function () {
      delete this.silent;
    };

    // check all wasm object properties/functions to wrap...
    const prototype = objInfo.registeredClass.instancePrototype;
    wrapObsPrototype(obsMap, wasmObs, prototype, cleanObjName, viewerControl);

    // same for base class (if any)...
    const basePrototype = objInfo.registeredClass.baseClass?.instancePrototype;
    if (basePrototype) {
      wrapObsPrototype(
        obsMap,
        wasmObs,
        basePrototype,
        cleanObjName,
        viewerControl,
      );
    }

    // same for base-base class (if any)...
    const baseBasePrototype =
      objInfo.registeredClass.baseClass?.baseClass?.instancePrototype;
    if (baseBasePrototype) {
      wrapObsPrototype(
        obsMap,
        wasmObs,
        baseBasePrototype,
        cleanObjName,
        viewerControl,
      );
    }

    // store observable (so we can reuse it)
    obsMap.set(mapKey, wasmObs);
  }

  return obsMap.get(mapKey);
};

const wrapObsPrototype = (
  obsMap,
  wasmObservable,
  prototype,
  cleanObjName,
  viewerControl,
) => {
  const wasmObject = wasmObservable._wasm;

  for (const prop in prototype) {
    if (hasOwnProperty.call(prototype, prop)) {
      // not inherited...
      if (!typeMapNames.includes(prop)) {
        // not internal stuff...
        if (isFunction(wasmObject[prop])) {
          // func
          const [args, ret] = getWasmCallSignature(
            prototype,
            `${cleanObjName}.${prop}`,
          );
          addObsFunction(
            obsMap,
            wasmObservable,
            prop,
            args,
            ret,
            viewerControl,
          );
        } else {
          // property..
          const [itType, itArgTypes] = getIterableType(
            wasmObject[prop],
            viewerControl,
          );
          if (itType) {
            if (itArgTypes != null) {
              // structured object (map, array)...
              addObIterableAtt(
                obsMap,
                wasmObservable,
                prop,
                itType,
                itArgTypes,
                viewerControl,
              );
            } else {
              wasmObservablesFail(
                viewerControl,
                new WasmObservableError(
                  `undefined signature for iterable type: ${cleanObjName} ${prop}`,
                ),
              );
            }
          } else {
            // attribute (get/set)...
            const [argsType, retType] = getWasmCallSignature(prototype, prop);
            if (argsType && argsType.length > 0) {
              // this should be null...
              viewerControl.logWarn(
                `non-null args in attribute: ${cleanObjName} ${prop}`,
              );
            }
            addObsAttribute(
              obsMap,
              wasmObservable,
              prop,
              retType,
              viewerControl,
            );
          }
        }
      }
    }
  }
};

const addObsAttribute = (
  obsMap,
  wasmObservable,
  attName,
  retType,
  viewerControl,
) => {
  Object.defineProperty(wasmObservable, attName, {
    get() {
      if (viewerControl.viewerFailed) {
        return undefined;
      }

      wasmObservable._atom.reportObserved();
      let ret;
      try {
        ret = wasmObservable._wasm[attName];
      } catch (e) {
        const msg = viewerControl.getExceptionMessage(e.toString());
        let err = e;
        if (msg) {
          err = new WasmObservableException(msg);
        }
        wasmObservablesFail(viewerControl, err, attName);
        return ret;
      }

      // make returned object observable (if wasm object)
      if (checkWasmObject(ret)) {
        ret = makeWasmObservable(obsMap, ret, viewerControl);
      }

      return ret;
    },
    set(x) {
      // check input (type, equalsOld...)
      // TODO
      if (viewerControl.viewerFailed) {
        return;
      }

      try {
        wasmObservable._wasm[attName] = x;
      } catch (e) {
        const msg = viewerControl.getExceptionMessage(e.toString());
        let err = e;
        if (msg) {
          err = new WasmObservableException(msg);
        }
        wasmObservablesFail(viewerControl, err, attName);
      }
      if (wasmObservable.silent !== true) {
        wasmObservable._atom.reportChanged();
      }
    },
  });

  if (_debug) console.log(debugLogPre, attName, debugRetLog, retType);
};

const addObsFunction = (
  obsMap,
  wasmObservable,
  attName,
  argTypes,
  retType,
  viewerControl,
) => {
  // check return type
  const [itType, itArgTypes] = getIterableTypeForLabel(retType, viewerControl);
  if (itType) {
    // it is an iterable type...
    if (itArgTypes == null) {
      wasmObservablesFail(
        viewerControl,
        new WasmObservableError(
          `undefined signature for iterable type: ${retType}`,
        ),
        attName,
      );
      return;
    }
  }
  const wrapperFunc = function (...args) {
    // TODO: check arguments...
    // if an argument is a wasmObservable, we can get its ._wasm here...
    if (viewerControl.viewerFailed) {
      return undefined;
    }

    let ret;
    try {
      ret = wasmObservable._wasm[attName].apply(wasmObservable._wasm, args);
    } catch (e) {
      const msg = viewerControl.getExceptionMessage(e.toString());
      let err = e;
      if (msg) {
        err = new WasmObservableException(msg);
      }
      wasmObservablesFail(viewerControl, err, attName);
      return ret;
    }

    if (checkWasmObject(ret)) {
      // make returned object observable (if wasm object)
      if (!itType) {
        ret = makeWasmObservable(obsMap, ret, viewerControl);
      } else {
        // returned object is an iterable
        ret = makeIterableWasmObservable(
          obsMap,
          ret,
          wasmObservable,
          attName,
          itType,
          itArgTypes,
          viewerControl,
        );
      }
    }

    if (wasmObservable.silent !== true) {
      if (ret == null && retType == null) {
        // if no output, this is a setter/updater...
        wasmObservable._atom.reportChanged();
      } else {
        wasmObservable._atom.reportObserved();
      }
    }

    if (_debug) {
      console.log(
        debugLogPre,
        'addObsFunctionWrapper',
        attName,
        argTypes,
        debugRetLog,
        retType ?? 'VOID',
        ret,
      );
    }

    return ret;
  };
  wasmObservable[attName] = wrapperFunc;

  // debug
  if (_debug) {
    console.log(
      debugLogPre,
      'addObsFunction',
      attName,
      argTypes,
      debugRetLog,
      retType ?? 'VOID',
    );
  }
};

// iterable object (e.g. map, vector)
const addObIterableAtt = (
  obsMap,
  wasmObservable,
  attName,
  itType,
  itArgTypes,
  viewerControl,
) => {
  // "owner" getter for this iterable itself
  Object.defineProperty(wasmObservable, attName, {
    get() {
      if (viewerControl.viewerFailed) {
        return undefined;
      }

      // "special" wrapper for iterable object (whose inner prototype is: get(), set(), size()...)
      let wasmItObj;
      try {
        wasmItObj = wasmObservable._wasm[attName];
      } catch (e) {
        const msg = viewerControl.getExceptionMessage(e.toString());
        let err = e;
        if (msg) {
          err = new WasmObservableException(msg);
        }
        wasmObservablesFail(viewerControl, err, attName);
        return wasmItObj;
      }
      const parentAtom = wasmObservable._atom;
      const wasmItObs = makeIterableWasmObservable(
        obsMap,
        wasmItObj,
        wasmObservable,
        attName,
        itType,
        itArgTypes,
        viewerControl,
      );
      // report to parent atom (the "owner" of this iterable)
      parentAtom.reportObserved();
      return wasmItObs;
    },
  });

  if (_debug) {
    console.log(
      debugLogPre,
      'addObIterableAtt',
      attName,
      debugRetLog,
      itType,
      itArgTypes,
    );
  }
};

// "special" atom wrapper for (inner) iterable property objects
const makeIterableWasmObservable = (
  obsMap,
  itWasmObj,
  parentObs,
  parentAttName,
  itType,
  itArgTypes,
  viewerControl,
) => {
  // e.g. map<string,Note>
  if (!parentObs || !parentObs._wasm || !parentObs._atom) {
    wasmObservablesFail(
      viewerControl,
      new WasmObservableError('cannot makeIterableWasmObservable on parent'),
    );
    return null;
  }

  const itObjInfo = itWasmObj.$$.ptrType;
  const isPointer = itObjInfo.name.slice(-1) === '*';
  const cleanItObjName = itObjInfo.name.replace('*', '');

  const parentMapKey = getUuid(parentObs._wasm);
  const mapKey = `${parentMapKey}.${parentAttName}.${cleanItObjName}`;

  if (isPointer && obsMap.has(mapKey)) {
    // reuse awsm observable object
    return obsMap.get(mapKey);
  }

  if (_debug) {
    console.log(' ', 'WRAPPING iterable wasmObserver', mapKey);
    console.log(debugLogInnerPre, itType, itArgTypes);
  }

  // reused atom (reports to parent)
  const parentAtom = parentObs._atom;
  // new observable (wrapper) object...
  const itWasmObs = {
    _wasm: itWasmObj,
    _atom: parentAtom,
    _itType: itType,
    _itArgTypes: itArgTypes,
  };

  // check all wasm object properties/functions to wrap...
  const itPrototype = itObjInfo.registeredClass.instancePrototype;
  wrapIterableObsPrototype(
    obsMap,
    itWasmObs,
    itPrototype,
    itType,
    itArgTypes,
    viewerControl,
  );

  if (isPointer) {
    // store observable (so we can reuse it)
    obsMap.set(mapKey, itWasmObs);
    return obsMap.get(mapKey);
  }

  return itWasmObs;
};

const wrapIterableObsPrototype = (
  obsMap,
  wasmObservable,
  prototype,
  itType,
  itArgTypes,
  viewerControl,
) => {
  const wasmObject = wasmObservable._wasm;

  // iterable object "standard" prototype function
  // map: [get, set, size, keys],
  // vector: [get, set, size, resize, push]
  for (const prop in prototype) {
    if (hasOwnProperty.call(prototype, prop)) {
      // not inherited...
      if (!typeMapNames.includes(prop)) {
        // not internal stuff...
        if (isFunction(wasmObject[prop])) {
          // func
          addIterableObsFunction(
            obsMap,
            wasmObservable,
            prop,
            itArgTypes,
            viewerControl,
          );
        } else {
          wasmObservablesFail(
            viewerControl,
            new WasmObservableError(
              'non-function prototype entry in iterable object',
            ),
          );
        }
      }
    }
  }

  if (itType === 'vector') {
    // add [Symbol.iterator]
    addVectorIterator(wasmObservable);
  }
};

const addIterableObsFunction = (
  obsMap,
  wasmObservable,
  attName,
  argTypes,
  viewerControl,
) => {
  const wrapperFunc = function (...args) {
    if (viewerControl.viewerFailed) {
      return undefined;
    }

    let ret;
    try {
      ret = this._wasm[attName].apply(this._wasm, args);
    } catch (e) {
      const msg = viewerControl.getExceptionMessage(e.toString());
      let err = e;
      if (msg) {
        err = new WasmObservableException(msg);
      }
      wasmObservablesFail(viewerControl, err, attName);
      return ret;
    }

    if (argTypes.length === 0) {
      wasmObservablesFail(
        viewerControl,
        new WasmObservableError(
          `no signature data for iterable property: ${attName}`,
        ),
        attName,
      );
      return ret;
    }

    if (attName === 'get') {
      // make returned object observable (if wasm object)
      if (checkWasmObject(ret)) {
        ret = makeWasmObservable(obsMap, ret, viewerControl);
      }
    } else if (attName === 'keys') {
      // add [Symbol.iterator]
      addVectorIterator(ret);
    }

    if (attName === 'set' || attName === 'push') {
      // TODO: type check
      // const retType = argTypes[argTypes.size() - 1];
      this._atom.reportChanged();
    } else {
      this._atom.reportObserved();
    }
    return ret;
  };
  wasmObservable[attName] = wrapperFunc;

  // debug
  if (_debug)
    console.log(debugLogInnerPreProt, 'addIterableObsFunction', attName);
};

export function isIterable(obj) {
  // checks for null and undefined
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === 'function';
}

const addVectorIterator = itObj => {
  if (itObj) {
    itObj[Symbol.iterator] = function () {
      const n = itObj.size();
      let i = 0;
      return {
        next: () => ({
          done: i >= n,
          // eslint-disable-next-line no-plusplus
          value: itObj.get(i++),
        }),
      };
    };
    // debug
    if (_debug2) console.log(debugLogInnerPreProt, 'vector:@iterator', itObj);
  }
};
